import Lock from '@mui/icons-material/Lock';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { FormControl, InputLabel, MenuItem, Select as MuiSelect } from '@mui/material';
import { Field } from 'react-final-form';
import { ErrorMessage, showDefaultError, useFieldForErrors } from '../Util';

const withoutInitialValuesDefinedInAdvance = (value, multiple) => (multiple && !value ? [] : value);

const Select = props => {
  const {
    name,
    label,
    data,
    children,
    required,
    multiple,
    helperText,
    fieldProps,
    inputLabelProps,
    formHelperTextProps,
    menuItemProps,
    onManualChange,
    showError = showDefaultError,
    ...restSelectProps
  } = props;

  const { variant = 'outlined' } = restSelectProps;
  const field = useFieldForErrors(name);
  const isError = showError(field);
  console.log(fieldProps);
  return (
    <Field
      name={name}
      render={({ input: { name, value, onChange, ...restInput } }) => {
        const handleChange = e => {
          onChange(e);
          if (onManualChange) {
            onManualChange(e);
          }
        };
        const finalValue = withoutInitialValuesDefinedInAdvance(value, multiple);
        const labelId = `select-input-${name}`;
        const lockComponent = variant === 'outlined' ? LockOutlinedIcon : Lock;
        return (
          <FormControl
            required={required}
            error={isError}
            fullWidth
            variant={variant}
            disabled={restSelectProps?.disabled}
          >
            {!!label && (
              <InputLabel id={labelId} {...inputLabelProps}>
                {label}
              </InputLabel>
            )}
            <MuiSelect
              IconComponent={restSelectProps.disabled && !restSelectProps.withoutLock ? lockComponent : undefined}
              name={name}
              value={finalValue}
              title={finalValue}
              onChange={handleChange}
              multiple={multiple}
              label={label}
              labelId={labelId}
              inputProps={{ required, ...restInput }}
              {...restSelectProps}
            >
              {data
                ? data.map((item, index) => (
                    <MenuItem
                      value={item.value}
                      key={`${item.value}-${index}`}
                      disabled={item.disabled}
                      {...menuItemProps}
                    >
                      {item.label}
                    </MenuItem>
                  ))
                : children}
            </MuiSelect>
            <ErrorMessage
              showError={isError}
              meta={field.meta}
              formHelperTextProps={formHelperTextProps}
              helperText={helperText}
            />
          </FormControl>
        );
      }}
      {...fieldProps}
    />
  );
};

export default Select;
